import { useMemo } from 'react';
import { Platform } from 'react-native';
import { theme } from '@/constants/theme';
import { useAccessibility } from '@/contexts/AccessibilityContext';
import {
  getScaledFontSize,
  getAccessibleColor,
  getAccessibleBackgroundColor,
  getAccessibleTextColor,
  getAccessibleFontFamily,
  getHeaderStyles,
} from '@/utils/accessibilityHelpers';

export interface ChatStyles {
  container: {
    backgroundColor: string;
  };
  logo: {
    fontSize: number;
    fontFamily: string;
    color: string;
    [key: string]: any;
  };
  input: {
    fontSize: number;
    fontFamily: string;
    color: string;
  };
  inputContainer: {
    backgroundColor: string;
    borderColor: string;
  };
  sendButton: {
    backgroundColor: string;
  };
}

export function useChatStyles(): ChatStyles {
  const { settings } = useAccessibility();

  return useMemo(() => ({
    container: {
      backgroundColor: getAccessibleBackgroundColor(theme.colors.background, settings),
    },
    logo: {
      fontSize: getScaledFontSize(Platform.OS === 'web' ? 32 : 20, settings.fontSize),
      fontFamily: getAccessibleFontFamily(theme.fonts.bold, settings),
      color: getAccessibleColor(theme.colors.primary, settings),
      ...getHeaderStyles(settings),
    },
    input: {
      fontSize: getScaledFontSize(16, settings.fontSize),
      fontFamily: getAccessibleFontFamily(theme.fonts.regular, settings),
      color: getAccessibleTextColor(theme.colors.text, settings),
    },
    inputContainer: {
      backgroundColor: getAccessibleBackgroundColor(theme.colors.surface, settings),
      borderColor: getAccessibleColor(theme.colors.border, settings),
    },
    sendButton: {
      backgroundColor: getAccessibleColor('#8B5CF6', settings),
    },
  }), [settings]);
}
